import React, { useState, useEffect } from "react"
import { Modal, Form, Input, Radio, message } from "antd"
import { intentionFranchisePage, intentionFranchiseUpdate } from "@/service/orgService"

const Detail = ({ rowInfo, visible, mode, setVisible, onSuccess }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (visible && Object.keys(rowInfo).length) {
      form.setFieldsValue({
        follow: rowInfo.follow,
        remark: rowInfo.remark
      })
    }
  }, [visible, rowInfo])

  const handleOk = () => {
    form.validateFields().then((values) => {
      setLoading(true)
      intentionFranchiseUpdate({
        id: rowInfo.id,
        ...values
      }).then((res) => {
        message.success("更新成功")
        setVisible(false)
        onSuccess()
      }).finally(() => {
        setLoading(false)
      })
    })
  }

  return (
    <Modal
      title="编辑意向加盟"
      visible={visible}
      onOk={handleOk}
      onCancel={() => setVisible(false)}
      confirmLoading={loading}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
      >
        <Form.Item
          label="是否回访"
          name="follow"
          rules={[{ required: true, message: "请选择是否回访" }]}
        >
          <Radio.Group>
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="备注"
          name="remark"
        >
          <Input.TextArea rows={4} placeholder="请输入备注信息" />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default Detail 